<template>
  <v-bottom-navigation
    v-if="$vuetify.breakpoint.mobile"
    class="d-lg-none"
    app
    grow
    color="primary"
    background-color="cardSurface"
  >
    <v-btn
      :to="{ name: 'Dashboard' }"
      icon
      exact
      class="removeBtnBackground"
      :ripple="false"
    >
      <span>Dashboard</span>
      <v-icon> mdi-view-dashboard </v-icon>
    </v-btn>
    <v-btn
      :to="{ name: 'Projects' }"
      icon
      class="removeBtnBackground"
      :ripple="false"
    >
      <span>Prosjekter</span>
      <v-icon>mdi-home-city</v-icon>
    </v-btn>
    <!-- <v-btn
      :to="{ name: 'Profile' }"
      icon
      class="removeBtnBackground"
      :ripple="false"
    >
      <span>Profil</span>
      <v-icon> mdi-account </v-icon>
    </v-btn> -->
    <v-btn
      v-if="profile"
      :to="{ name: 'Profile' }"
      icon
      class="removeBtnBackground"
      :ripple="false"
    >
      <span>Profil</span>
      <v-badge
        :value="isBookingActive"
        class="badgeSize"
        color="primary"
        overlap
      >
        <template v-slot:badge>
          <v-icon color="iconOnPrimary">mdi-calendar-check</v-icon>
        </template>
        <v-avatar size="24">
          <v-img
            :lazy-src="
              contactpersonApi.getProfilePhoto(
                profile.person.email,
                profileImageUpdate
              )
            "
            :src="
              contactpersonApi.getProfilePhoto(
                profile.person.email,
                profileImageUpdate
              )
            "
            max-height="180"
        /></v-avatar>
      </v-badge>
    </v-btn>
    <v-btn
      v-if="isTrysilhus === false"
      :to="{ name: 'Company' }"
      icon
      class="removeBtnBackground"
      :ripple="false"
    >
      <span>Firma</span>
      <v-icon> mdi-briefcase-variant </v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import contactpersonApi from "@/api/contactpersonApi";

export default {
  data() {
    return {
      active: null,
      contactpersonApi,
    };
  },
  methods: {
    ...mapActions({
      setBookingActive: "profile/setBookingActive",
    }),
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      profileImageUpdate: "shared/profileImageUpdate",
      isBookingActive: "profile/isBookingActive",
    }),
  },
};
</script>

<style lang="scss">
.v-bottom-navigation {
  height: calc(56px + env(safe-area-inset-bottom)) !important;

  padding-bottom: env(safe-area-inset-bottom);

  .v-btn {
    height: 100% !important;
  }
}

.badgeSize {
  .v-icon {
    height: 12px !important;
    font-size: 12px !important;
    width: 12px !important;
  }
}
</style>
